import { Component, Inject } from '@angular/core';
import { MatDialogModule, MatDialogContent, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DynamicDataTableComponent } from '../../../layout/dynamic-data-table/dynamic-data-table.component';
import { DataTableSchema } from '../../../model/dynamic-data-table.model';
import { OEMTenureDetailTableSchema } from '../../../model/tenure/oem-tenure.model';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-oem-tenure-detail',
  standalone: true,
  imports: [DynamicDataTableComponent,MatDialogModule, MatDialogContent,MatIconModule],
  templateUrl: './oem-tenure-detail.component.html',
  styleUrl: './oem-tenure-detail.component.scss'
})
export class OemTenureDetailComponent {
  dataTableSchema: DataTableSchema = OEMTenureDetailTableSchema;
  
  constructor(public dialogRef: MatDialogRef<OemTenureDetailComponent>,@Inject(MAT_DIALOG_DATA) public data: any  ) { 
  }

}


